export type NotificationStatus = 'success' | 'fail' | 'pending' | string;

export const getStatus = (status: NotificationStatus): string => {
  switch (status) {
    case 'success':
      return 'הצלחה';
    case 'fail':
      return 'כשלון';
    case 'pending':
      return 'בתהליך';
    default:
      return status || '';
  }
};